//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('oeeStateRemark', {
//        templateUrl: 'views/components/views/oeeStateRemark/oeeStateRemark.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'oeeStateRemarkService', function ($stateParams, stateService, oeeStateRemarkService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let oeeStateKeyno = $stateParams.oeestate_keyno;
//            let oeeStateRemarkKeyno = $stateParams.oeestateremark_keyno;

//            vm.model = {
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadEdit() {
//                vm.model.edit = (await oeeStateRemarkService.getEdit({
//                    oeestate_keyno: oeeStateKeyno,
//                    oeestateremark_keyno: oeeStateRemarkKeyno
//                }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                oeeStateRemarkService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
